import angular from 'angular';
import ngResource from 'angular-resource';
import UniquePartModelService from './unique-part-model.service';
import ParameterValueModelService from './parameter-value-model.service';
import DefinitionModelService from './definition-model.service';

export default angular.module('ModelModule', [ngResource])
    .factory('DefinitionModelService', DefinitionModelService)
    .factory('ParameterValueModelService', ParameterValueModelService)
    .factory('UniquePartModelService', UniquePartModelService)

    .name; // must come last
